import type { SelectionMode } from "./DataTable";

interface SelectionModeControlProps {
  value: SelectionMode;
  onChange: (mode: SelectionMode) => void;
}

const modes: Array<{ value: SelectionMode; label: string }> = [
  { value: "none", label: "Off" },
  { value: "single", label: "Single" },
  { value: "multi", label: "Multi" },
];

export const SelectionModeControl = ({
  value,
  onChange,
}: SelectionModeControlProps) => (
  <div className="flex items-center gap-1 bg-card rounded-btn border border-border p-1">
    <span className="text-xs text-muted-foreground px-2">Select</span>
    {modes.map((m) => (
      <button
        key={m.value}
        type="button"
        onClick={() => onChange(m.value)}
        className={`px-2.5 py-1 text-xs rounded-btn font-medium transition-colors ${
          value === m.value
            ? "bg-primary text-primary-foreground"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        {m.label}
      </button>
    ))}
  </div>
);

export default SelectionModeControl;
